
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent} from 'vue';
import Popper from "vue3-popper";

export default defineComponent({
    name: "PriceTable",
    components: {
        Popper
    },
    props: {
        priceGroups: {
            type: Array,
            required: true
        },
        ticketPrices: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, { emit }) {
        return {
            translate,
        }
    }
})
